import { Select as AntSelect, type SelectProps as AntSelectProps } from 'antd';
import { forwardRef } from 'react';
import './Select.css';

export interface SelectProps extends AntSelectProps {
  /**
   * Error state
   */
  error?: boolean;
  /**
   * Helper text below select
   */
  helperText?: string;
}

/**
 * Modern Select Component
 *
 * Dropdown selector with search
 *
 * @example
 * ```tsx
 * <Select
 *   placeholder="Select an option"
 *   options={[
 *     { value: '1', label: 'Option 1' },
 *     { value: '2', label: 'Option 2' },
 *   ]}
 * />
 * ```
 */
export const Select = forwardRef<any, SelectProps>(
  ({ error, helperText, className, status, ...props }, ref) => {
    const classNames = [
      'modern-select',
      error && 'modern-select--error',
      className,
    ]
      .filter(Boolean)
      .join(' ');

    return (
      <div className="modern-select-wrapper">
        <AntSelect
          ref={ref}
          status={error ? 'error' : status}
          className={classNames}
          {...props}
        />
        {helperText && (
          <div className={`modern-select__helper ${error ? 'modern-select__helper--error' : ''}`}>
            {helperText}
          </div>
        )}
      </div>
    );
  }
);

Select.displayName = 'Select';
